import api from './apiHelper';

export const getActivityLogsWithAggregation = (query = {}) => api.get('/activityLog/aggregation', { params: query });
